import { createAction, props } from '@ngrx/store';
import { DealerCriteria } from 'src/app/public/account/models/dealer-criteria.model';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { CarBrief } from 'src/app/public/car/models/car-brief.model';
import { CarCriteria } from 'src/app/public/car/models/car-criteria.model';
import { Car } from 'src/app/public/car/models/car.model';
import { JobCriteria } from 'src/app/public/keep/models/job-criteria.model';
import { Job } from 'src/app/public/keep/models/job.model';



export class SearchActions {

    
    public static switchBusinessLine = createAction(
        '[Session Component] Switch business line',
        props <{ businessLine: CarBusinessLine }> ()
    );
    
    // preview criteria submit

    public static searchPreviewCriteriaSubmit = createAction(
        '[SearchCriteria Component] Search Preview Criteria Submit',
        props <{ carCriteria: CarCriteria }> ()
    );

    public static dealersPreviewCriteriaSubmit = createAction(
        '[DealerCriteria Component] Dealers Preview Criteria Submit',
        props <{ dealerCriteria: DealerCriteria }> ()
    );

    public static activitiesPreviewCriteriaSubmit = createAction(
        '[JobCriteria Component] Activities Preview Criteria Submit',
        props <{ jobCriteria: JobCriteria }> ()
    );

    // criteria submit

    public static searchCriteriaSubmit = createAction(
        '[SearchCriteria Component] Search Criteria Submit',
        props <{ carCriteria: CarCriteria }> ()
    );

    public static dealerCriteriaSubmit = createAction(
        '[DealerCriteria Component] Dealer Criteria Submit',
        props <{ dealerCriteria: DealerCriteria }> ()
    );

    public static jobCriteriaSubmit = createAction(
        '[JobCriteria Component] Job Criteria Submit',
        props <{ jobCriteria: JobCriteria }> ()
    );

    //

    public static fetchSimilarCarBriefsSubmit = createAction(
        '[Car Details Component] Search Similar Cars Submit',
        props <{ carId: string, offerId: string, businessLine: CarBusinessLine }> ()
    );

    public static fetchRecentCarBriefsSubmit = createAction(
        '[Car Details Component] Search Recent Cars Submit',
        props <{ countryCodes: string[], businessLine: CarBusinessLine }> ()
    );

    public static fetchSameSellerCarBriefsSubmit = createAction(
        '[car Details Page Component] Search Same Seller Car Briefs Submit',
        props <{ sellerId: string, businessLine: CarBusinessLine }> ()
    );

    public static fetchSameSellerCarsSubmit = createAction(
        '[Seller Public Page Component] Search Same Seller Cars Submit',
        props <{ sellerId: string, businessLine: CarBusinessLine }> ()
    );


    //preview results success
    public static searchPreviewResultsSuccess = createAction(
        '[Search API] Search Preview Results Success',
        props <{ carsPreview: any }> ()
    );

    public static dealersPreviewResultsSuccess = createAction(
        '[Search API] Dealers Preview Results Success',
        props <{ dealersPreview: any }> ()
    );

    public static activitiesPreviewResultsSuccess = createAction(
        '[Search API] Activities Preview Results Success',
        props <{ activitiesPreview: any }> ()
    );

    
    // search results success
    public static searchResultsSuccess = createAction(
        '[Search API] Search Results Success',
        props <{ cars: Car[] }> ()
    );

    public static dealerResultsSuccess = createAction(
        '[Search API] Dealer Results Success',
        props <{ dealers: Dealer[] }> ()
    );

    public static jobResultsSuccess = createAction(
        '[Search API] Job Results Success',
        props <{ activities: Job[] }> ()
    );


    // reset search form
    public static resetCarCriteriaForm = createAction(
        '[CarCriteria Form] Reset Car Criteria Form'
    );

    public static resetDealerCriteriaForm = createAction(
        '[DealerCriteria Form] Reset Dealer Criteria Form'
    );

    public static resetJobCriteriaForm = createAction(
        '[JobCriteria Form] Reset Job Criteria Form'
    );


    // others
    public static fetchSimilarCarBriefsSuccess = createAction(
        '[Search API] Search Similar Car Briefs Success',
        props <{ carBriefs: CarBrief[] }> ()
    );

    public static fetchRecentCarBriefsSuccess = createAction(
        '[Search API] Search Recent Car Briefs Success',
        props <{ carBriefs: CarBrief[] }> ()
    );

    public static fetchSameSellerCarBriefsSuccess = createAction(
        '[Search API] Search Same Seller  car Briefs Success',
        props <{ carBriefs: CarBrief[] }> ()
    );

    public static fetchSameSellerCarsSuccess = createAction(
        '[Search API] Search Same Seller Cars Success',
        props <{ cars: Car[], businessLine: CarBusinessLine }> ()
    );

    public static initCarCriteriaForm = createAction(
        '[CarCriteria Form] Init Car Criteria Form'
    );

    public static initCarSearchResultsComponent = createAction(
        '[CarCriteria Form] Init Car Search Results Component'
    );

    public static fetchCarDetailsSubmit = createAction(
        '[Car Details Form] Init Car Details Component',
        props <{ offerId: string, carId: string, businessLine: CarBusinessLine }> ()
    );


    public static fetchCarDetailsAndImagesSubmit = createAction(
        '[Car Details Form] Init Car Details Component',
        props <{ offerId: string, carId: string, businessLine: CarBusinessLine }> ()
    );

    public static fetchCarDetailsSuccess = createAction(
        '[Search API] Fetch Car Details Success',
        props <{ car: Car }> ()
    );

    public static searchedCarsFetchError = createAction(
        '[Dealer API Error] Searched Cars fetch Error',
        props <{ errorMessage: string }> ()
    );

    public static changeSelectedCountriesSubmit = createAction(
        '[Search API] Change Selected Countries Submit',
        props <{ countryCodes: string[] }> ()
    );

}
